namespace TabAurous.Production {
    export interface SplittingBOMForm {
        TransItemId: Serenity.StringEditor;
        TransId: Serenity.StringEditor;
        ProductId: Serenity.StringEditor;
        BomProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        Line_No: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
        SettingId: Serenity.LookupEditor;
        Weight: Serenity.DecimalEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: Serenity.DecimalEditor;
        StoneStatusId: Serenity.LookupEditor;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
        RefVoucherId: Serenity.IntegerEditor;
        RefTransId: Serenity.StringEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransBomId: Serenity.StringEditor;
    }

    export class SplittingBOMForm extends Serenity.PrefixedContext {
        static formKey = 'Production.SplittingBOM';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SplittingBOMForm.init)  {
                SplittingBOMForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(SplittingBOMForm, [
                    'TransItemId', w0,
                    'TransId', w0,
                    'ProductId', w0,
                    'BomProductId', w0,
                    'AttributeId', w0,
                    'BagNo', w0,
                    'Line_No', w0,
                    'Pieces', w1,
                    'SettingId', w2,
                    'Weight', w3,
                    'Purity', w3,
                    'PureWeight', w3,
                    'StoneStatusId', w2,
                    'Lab', w2,
                    'CertificateNo', w0,
                    'CompanyId', w1,
                    'FinancialYearId', w1,
                    'UserId', w1,
                    'RefVoucherId', w1,
                    'RefTransId', w0,
                    'RefTransItemId', w0,
                    'RefTransBomId', w0
                ]);
            }
        }
    }
}
